import { Button as AntButton, Modal } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { createHoliday } from "../../../../api/holidays.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  holidayDate: any;
  doGetHolidays: () => void;
}

const CreateHolidayModal: FC<IProps> = ({
  visible,
  setVisible,
  holidayDate,
  doGetHolidays,
}) => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const { data: createData, isLoading: createIsLoading, error: createError, execute: createExecute } = useAxios();

  const [holidayName, setHolidayName] = useState('');
  
  useEffect(() => {
    if (createData && !createIsLoading) {
      successNotification(t('common.message.create'));
      setVisible(false);
      doGetHolidays();
    }
  }, [createData, createIsLoading]);

  const onCreate = () => {
    if (!holidayName) {
      return infoNotification(t('program.holiday.message1'));
    }

    createExecute(createHoliday({
      holidayDate: moment(holidayDate).format('YYYYMMDD'),
      holidayName
    }));
  }

  return (
    <>
      {createIsLoading && <Loader />}
      <ErrorResponse error={createError} />
      <Modal
        title={t('program.holiday.column1')}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onCreate}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => {
                setVisible(false);
              }}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="form-group row mx-5">
          <label
            htmlFor="inputEmail3"
            className="col-2 col-form-label text-right"
          >
            {t('program.holiday.column2')}
          </label>
          <div className="col-10">
            <input
              type="text"
              className="form-control input-text"
              value={moment(holidayDate).format('YYYY-MM-DD')}
              readOnly
            />
          </div>
        </div>
        <div className="form-group row mx-5">
          <label
            htmlFor="inputEmail3"
            className="col-2 col-form-label text-right"
          >
            {t('program.holiday.column3')}
          </label>
          <div className="col-10">
            <input
              type="text"
              className="form-control input-text"
              value={holidayName}
              onChange={e => setHolidayName(e.target.value)}
            />
          </div>
        </div>
        <div className="text-center">
          {t('program.holiday.text5')}
        </div>
      </Modal>    
    </>
  );
};

export default CreateHolidayModal;
